<div *ngIf='ready' class='AppSelect' [id]="autoID">
  <ng-select
    #selectElement
    (clear)='onClear($event)'
    (ngModelChange)='writeValue($event)'
    [(ngModel)]='value'
    [class.bg-white]='colorWhite'
    [class.required]='
      control && (control.dirty || control.touched) && control.errors
    '
    [clearable]='false'
    [disabled]='disabled'
    [dropdownPosition]='dropdownPosition'
    [multiple]='multi'
    [placeholder]='multi ? label : null'
    [appendTo]='"#" + autoID'>
    <ng-option *ngFor='let item of properties.items' [value]='item'>{{
        item.label
      }}
    </ng-option>
    <ng-template *ngIf='!multi' let-item='item' ng-label-tmp>
      {{ label }}: {{ findLabel(value) }}
    </ng-template>
  </ng-select>
</div>
